/**
 * AdvancedSettings — slim shell that orchestrates 7 collapsible sections.
 * Each section lives in /components/advanced/ and manages its own state mutations.
 * The shell owns only the "which section is open" UI state.
 */
import React, { useState } from "react";
import StrategySection from "@/components/advanced/StrategySection";
import IncomeStreamsSection from "@/components/advanced/IncomeStreamsSection";
import TaxConfigSection from "@/components/advanced/TaxConfigSection";
import HealthcareSection from "@/components/advanced/HealthcareSection";
import RealEstateSection from "@/components/advanced/RealEstateSection";
import GlidePathSection from "@/components/advanced/GlidePathSection";
import RothConversionSection from "@/components/advanced/RothConversionSection";

const SECTIONS = [
  { key: "strategy", Component: StrategySection },
  { key: "income", Component: IncomeStreamsSection },
  { key: "tax", Component: TaxConfigSection },
  { key: "healthcare", Component: HealthcareSection },
  { key: "realestate", Component: RealEstateSection },
  { key: "glidepath", Component: GlidePathSection },
  { key: "roth", Component: RothConversionSection },
];

export default function AdvancedSettings({ inputs, setInputs }) {
  const [openSec, setOpenSec] = useState(null);
  const toggle = (k) => setOpenSec(openSec === k ? null : k);

  return (
    <div data-testid="advanced-settings" className="mt-5 border-t border-[#E5E2DC] pt-4 divide-y divide-[#E5E2DC]">
      {SECTIONS.map(({ key, Component }) => (
        <Component
          key={key}
          inputs={inputs}
          setInputs={setInputs}
          open={openSec === key}
          onToggle={() => toggle(key)}
        />
      ))}
    </div>
  );
}
